import React from 'react';
import { Button } from 'semantic-ui-react';
import { VariantConsumer, MenuConsumer, CartConsumer } from '../../../FoodMenu.context';
import { displayVariantComponentMap } from '../index';
import MenuUtil from '../../../utils/menu';
import MenuItemCartModal from '../../../../MenuItemCartModal';
import './Item.css';

class ItemContainer extends React.Component {
  constructor(props) {
    super(props);

    this.state = { modalOpen: false };

    this.handleOpen = this.handleOpen.bind(this);
    this.handleClose = this.handleClose.bind(this);
    this.getModalOpen = this.getModalOpen.bind(this);
  }

  handleOpen() {
    this.setState({ modalOpen: true });
  }

  handleClose() {
    this.setState({ modalOpen: false });
  }

  getModalOpen() {
    return this.state.modalOpen;
  }

  render() {
    const { itemId } = this.props;

    return (
      <MenuConsumer>
        {({ items, modifierSets, modifiers }) => {
          const item = MenuUtil.getItemById(items, itemId);
          const { _id, name, description, image, available = true, ...restItem } = item;
          const { modifierSets: itemModifierSetIds } = item;
          const itemModifierSets = MenuUtil.getItemModifierSets(itemModifierSetIds, modifierSets);

          return (
            <VariantConsumer>
              {({ itemDisplay }) => {
                const ItemComponent = displayVariantComponentMap.item[itemDisplay];

                return (
                  <CartConsumer>
                    {cart => {
                      if (cart === false) {
                        return (
                          <ItemComponent
                            isSingleVariation={MenuUtil.menuItemHasOneVariation(item)}
                            id={_id}
                            name={name}
                            description={description}
                            image={image}
                            variations={MenuUtil.getMenuItemVariations(item)}
                            {...restItem}
                          />
                        );
                      }

                      return (
                        <MenuItemCartModal
                          trigger={
                            <ItemComponent
                              className={!available && 'fcfm-menu-item-disabled'}
                              onClick={available ? this.handleOpen : () => null}
                              isSingleVariation={MenuUtil.menuItemHasOneVariation(item)}
                              id={_id}
                              name={name}
                              description={description}
                              image={image}
                              variations={MenuUtil.getMenuItemVariations(item)}
                              {...restItem}
                            />
                          }
                          open={this.getModalOpen()}
                          onClose={this.handleClose}
                          item={item}
                          modifiers={modifiers}
                          modifierSets={itemModifierSets}
                          variations={MenuUtil.getMenuItemVariations(item)}
                          cart={cart}
                        />
                      );
                    }}
                  </CartConsumer>
                );
              }}
            </VariantConsumer>
          );
        }}
      </MenuConsumer>
    );
  }
}

export default ItemContainer;
